<template>
  <div id="langham-form" class="container-fluid">
    <div class="welcome-text">
      <h4 class="welcome-head">Welcome to {{ propertyName }}!</h4>
      <p class="welcome-sub">Choose how you would like to connect</p>
    </div>

    <details v-if="formVariant === 'chicago' && hasRoomLogin" data-section="guests" :open="activeSection === 'guests'">
      <summary role="button" class="close-accordion" @click.prevent="setActiveSection('guests')">
        <div class="flod">
          <img v-if="activeSection === 'guests'" :src="assets.minusIcon" alt="">
          <img v-else :src="assets.plusIcon" alt="">
        </div>
        <p>Resident Guests</p>
      </summary>
      <div>
        <div class="form-contain">
          <form class="form-container" novalidate @submit.prevent="submitRoomGuests">
            <div class="two-wrapper">
              <div class="half">
                <label for="room_number" class="label-style">Room Number*</label>
                <input
                  type="text"
                  id="room_number"
                  v-model="form.room_guests.room_number"
                  class="input-style"
                  :class="{ 'has-content': form.room_guests.room_number }"
                />
                <span class="error-text" :class="{ visible: errors.room_number }">Please enter the room number</span>
              </div>
              <div class="half">
                <label for="last_name" class="label-style">Last Name*</label>
                <input
                  type="text"
                  id="last_name"
                  v-model="form.room_guests.last_name"
                  class="input-style"
                  :class="{ 'has-content': form.room_guests.last_name }"
                />
                <span class="error-text" :class="{ visible: errors.last_name }">Please enter your surname</span>
              </div>
            </div>
            <fieldset class="checkbox" id="checkbox-guests">
              <input type="checkbox" id="accept-form-guests" v-model="form.room_guests.terms" />
              <label for="accept-form-guests">I hereby agree with all the terms and conditions for the use of the internet*</label>
            </fieldset>
            <span class="error-text block-error" :class="{ visible: errors.room_terms }">Please agree to our internal terms and conditions</span>
            <button type="submit" class="top-bottom-margin solid-button center">CONNECT</button>
          </form>
        </div>
      </div>
    </details>

    <details v-if="formVariant === 'standard' && hasClickAndGo" data-section="terms" :open="activeSection === 'terms'">
      <summary role="button" class="close-accordion" @click.prevent="setActiveSection('terms')">
        <div class="flod">
          <img v-if="activeSection === 'terms'" :src="assets.minusIcon" alt="">
          <img v-else :src="assets.plusIcon" alt="">
        </div>
        <p>Guests</p>
      </summary>
      <div>
        <div class="form-contain">
          <form class="form-container" novalidate @submit.prevent="submitClickAndGo">
            <fieldset class="checkbox" id="checkbox-terms">
              <input type="checkbox" id="accept-form-terms" v-model="form.click_and_go.terms" />
              <label for="accept-form-terms">I hereby agree with all the terms and conditions for the use of the internet*</label>
            </fieldset>
            <span class="error-text block-error" :class="{ visible: errors.click_terms }">Please agree to our internet terms and conditions</span>
            <button type="submit" class="top-bottom-margin solid-button center">CONNECT</button>
          </form>
        </div>
      </div>
    </details>

    <details v-if="hasAccessCode" data-section="access" :open="activeSection === 'access'">
      <summary role="button" class="close-accordion" @click.prevent="setActiveSection('access')">
        <div class="flod">
          <img v-if="activeSection === 'access'" :src="assets.minusIcon" alt="">
          <img v-else :src="assets.plusIcon" alt="">
        </div>
        <p>Access Code</p>
      </summary>
      <div>
        <div class="form-contain">
          <form class="form-container" novalidate @submit.prevent="submitAccessCode">
            <label for="access_code" class="label-style">Access Code*</label>
            <input
              type="text"
              id="access_code"
              v-model="form.access_code.access_code"
              class="input-style"
              :class="{ 'has-content': form.access_code.access_code }"
            />
            <span class="error-text" :class="{ visible: errors.access_code }">Please enter the conference code</span>
            <fieldset class="checkbox" id="checkbox-ac">
              <input type="checkbox" id="accept-form-ac" v-model="form.access_code.terms" />
              <label for="accept-form-ac">I hereby agree with all the terms and conditions for the use of the internet*</label>
            </fieldset>
            <span class="error-text block-error" :class="{ visible: errors.access_terms }">Please agree to our internal terms and conditions</span>
            <button type="submit" class="top-bottom-margin solid-button center">CONNECT</button>
          </form>
        </div>
      </div>
    </details>
  </div>
</template>

<script>
import plusIcon from '@/components/custom/_langham2026/assets/img/plusIcon.svg';
import minusIcon from '@/components/custom/_langham2026/assets/img/minusIcon.svg';

export default {
  name: 'langham-form',
  props: {
    propertyName: { type: String, required: true },
    formVariant: { type: String, default: 'standard' },
    registration_methods: { type: Array, default: () => [] },
  },
  data() {
    return {
      activeSection: null,
      clicked: false,
      assets: { plusIcon, minusIcon },
      form: {
        click_and_go: { terms: false },
        room_guests: { room_number: null, last_name: null, terms: false },
        access_code: { access_code: null, terms: false },
      },
      errors: {},
    };
  },
  computed: {
    hasClickAndGo() {
      return this.registration_methods.some(rm => rm.registration_method_id === 1);
    },
    hasRoomLogin() {
      return this.registration_methods.some(rm => rm.registration_method_id === 2);
    },
    hasAccessCode() {
      return this.registration_methods.some(rm => rm.type === 'accesscode');
    },
  },
  mounted() {
    this.activeSection = this.formVariant === 'chicago' ? 'guests' : 'terms';
  },
  methods: {
    setActiveSection(section) {
      this.activeSection = section;
    },
    clearErrors() {
      this.errors = {};
    },
    findRegistrationMethod(id) {
      return this.registration_methods.find(rm => rm.registration_method_id === id);
    },
    emitRegistration(registration_method, extra = {}) {
      if (this.clicked) return;
      this.clicked = true;

      const emitted = {
        registration_method_id: registration_method.registration_method_id,
        rateplan_id: registration_method.id || null,
        email_address: null,
        last_name: extra.last_name || null,
        room_number: extra.room_number || null,
        access_code: extra.access_code || null,
      };

      this.$emit('emitRegistrationMethodData', emitted);
    },
    submitClickAndGo() {
      this.clearErrors();
      const rm = this.findRegistrationMethod(1);
      if (!rm) return;

      if (this.form.click_and_go.terms) {
        this.emitRegistration(rm);
        return;
      }
      this.errors.click_terms = true;
    },
    submitRoomGuests() {
      this.clearErrors();
      const rm = this.findRegistrationMethod(2);
      if (!rm) return;

      let valid = true;
      if (!this.form.room_guests.room_number) {
        this.errors.room_number = true;
        valid = false;
      }
      if (!this.form.room_guests.last_name) {
        this.errors.last_name = true;
        valid = false;
      }
      if (!this.form.room_guests.terms) {
        this.errors.room_terms = true;
        valid = false;
      }
      if (!valid) return;

      this.emitRegistration(rm, {
        last_name: this.form.room_guests.last_name,
        room_number: this.form.room_guests.room_number,
      });
    },
    submitAccessCode() {
      this.clearErrors();
      const rm = this.registration_methods.find(r => r.type === 'accesscode');
      if (!rm) return;

      let valid = true;
      if (!this.form.access_code.access_code) {
        this.errors.access_code = true;
        valid = false;
      }
      if (!this.form.access_code.terms) {
        this.errors.access_terms = true;
        valid = false;
      }
      if (!valid) return;

      this.emitRegistration(rm, {
        access_code: this.form.access_code.access_code,
      });
    },
  },
};
</script>

<style scoped>
.block-error {
  margin-left: 30px;
  margin-top: -6px;
}
</style>
